<template>
    <div :style="cssPropsInput" class="field-container" :class="class_width">
        <label :for="'booking_cms_input_' + config.value" :style="getStylesLabel">{{ config.label }}</label>
        <input :id="'booking_cms_input_' + config.value" v-model="inputValue" :style="getStylesInput" type="text">
    </div>
</template>

<script>

    export default{
        name: 'BookingInput',
        props:{
            attributes: Object,
            config: Object,
            icon: String,
            booking_data: Object,
            class_width: String
        },
        computed: {
            getStylesLabel(){
                const  { border , backgroundColor , fontSizeLabel , fontSizeLabelInside , fontSize , padding , ...rest  } = this.attributes
                const paddings = padding.split(' ')

                if( this.attributes['label-inside'] ){
                    return {
                        position: 'absolute',
                        transition: 'all 0.2s ease',
                        top: paddings[0],
                        left: paddings[3],
                        fontSize: fontSizeLabel,
                        pointerEvents: 'none',
                        ...rest
                    }
                }else{
                    return { 
                        ...rest,
                        fontSize: fontSizeLabel,

                    }
                }
               
            },
            getStylesInput(){
                const {  border , lineHeight , fontSizeLabel , fontSizeLabelInside  , ...rest } = this.attributes
                const backgroundImage = {
                    backgroundImage: this.config.value === 'rate' ? `url(${this.icon})` : 'none'
                }
                return{
                    ...rest,
                    ...backgroundImage,
                    backgroundSize: '20px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionY: 'center',
                    backgroundPositionX: 'calc(100% - 15px)',
                    borderTop: border.top,
                    borderBottom: border.bottom,
                    borderRight: border.right,
                    borderLeft: border.left,
                }
            },
            cssPropsInput(){
                const {  border , padding } = this.attributes
                return {
                    '--color-placeholder' :  this.attributes.color,
                    '--text-transform-placeholder': this.attributes.textTransform,
                }
            }
           
        },
        data(){
            return{
                inputValue: '',
                mutableBookingData: this.booking_data
            }
        },
        watch:{
            inputValue: function(){
                this.$parent.$parent.$emit('update-data',{
                    [this.config.value]: this.inputValue
                })
            }
        },
        methods:{
          
        },
        mounted(){
            // if( this.attributes['label-inside'] ){
            //     const { padding } = this.attributes
            //     const paddings = padding.split(' ')
            //     const fontSize = Number(paddings[0].split('px')[0])
            //     document.querySelectorAll('.field-container input').forEach((input) =>{
            //         input.addEventListener('focus' , function(){
            //             console.log('focust..' , this.attributes)
            //             this.previousElementSibling.style.fontSize = `${fontSize - 6}px`
            //             this.previousElementSibling.style.top = '2px'
            //         })
            //     })
            // }
        }
    }

</script>

<style lang="scss">
    .field-container{
        position: relative;
        input[type=text]{
            background-size: 17px;
            padding: 0;
            outline: none;
            &::placeholder{
                color: var(--color-placeholder);
                text-transform: var(--text-transform-placeholder);
                text-align: left;
            }
            
        }
    }
</style>

